import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-519e0f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row justify-content-center pt-5 gx-5",
  ref: "sectionMain",
  id: "section-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("header", { class: "col-lg-12 col-md-12 col-sm-12 d-flex align-items-baseline" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Viabilidade"),
    /*#__PURE__*/_createElementVNode("h6", { style: {"padding-left":"5px"} }, "(Dados físicos)")
  ])
], -1))
const _hoisted_3 = { class: "row section-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-subtitle" }, "Declividade e altimetria do terreno", -1))
const _hoisted_5 = { class: "row gy-3" }
const _hoisted_6 = { class: "col-lg-4 col-md-12 col-sm-12" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "col-lg-8 col-md-12 col-sm-12 d-flex flex-column justify-content-between",
  style: {"gap":"12px"}
}
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_responsive_table = _resolveComponent("responsive-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            class: _normalizeClass(["section-map", { 'blurred': _ctx.isBlockedOpportunity }]),
            src: _ctx.completeOpportunity.thumb_decli,
            alt: "map"
          }, null, 10, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesColumn1Area1, (table, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_responsive_table, {
                tableTitle: table.title,
                tableHeaders: table.headers,
                tableData: table.data,
                heatMapColors: table.info,
                pointColor: table.circleColor,
                showHeatMap: true,
                isCodeZone: true,
                isBlockedOpportunity: _ctx.isBlockedOpportunity,
                tableMaxHeight: '160px'
              }, null, 8, ["tableTitle", "tableHeaders", "tableData", "heatMapColors", "pointColor", "isBlockedOpportunity"])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.showHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_9))
      : _createCommentVNode("", true)
  ], 512))
}